import { z } from 'zod';

/** Server Category record. */
export interface ServerCategory {
  /** Unique ID for the category in SSRM. */
  readonly id: number;
  name: string;
}

/** Client Category record. */
export interface Category {
  /** Unique ID for the category in SSRM. */
  readonly id: number;
  name: string;
}

export const serverCategorySchema = z.object({
  id: z.number().int(),
  name: z.string(),
}) satisfies z.ZodType<ServerCategory>;

export const toClientCategory = (server: ServerCategory): Category => ({
  id: server.id,
  name: server.name,
});

export const categoriesResponseSchema = z
  .array(serverCategorySchema)
  .transform((categories): Category[] => categories.map(toClientCategory));
